module.exports = __webpack_public_path__ + "static/text@2x-a9c315a98aecf67138ef965644292b17.png";